export default {
    key: 'flexible_capacity',
    slug: 'flexible-capacity',
    variants: [
      {
        key: 'by_sector',
        slug: 'by-sector',
        series: [
            'myc_flexible_capacity_in_agriculture_p2h',
            'myc_flexible_capacity_in_energy_flexibility_flow_batteries',
            'myc_flexible_capacity_in_energy_flexibility_mv_batteries',
            'myc_flexible_capacity_in_energy_flexibility_opac',
            'myc_flexible_capacity_in_energy_flexibility_pumped_storage',
            'myc_flexible_capacity_in_energy_flexibility_synthetic_kerosene',
            'myc_flexible_capacity_in_energy_heat_flexibility_p2h_boiler',
            'myc_flexible_capacity_in_energy_heat_flexibility_p2h_heatpump',
            'myc_flexible_capacity_in_energy_hydrogen_flexibility_p2g_offshore',
            'myc_flexible_capacity_in_energy_hydrogen_flexibility_p2g',
            'myc_flexible_capacity_in_energy_interconnector_exported',
            'myc_flexible_capacity_in_households_flexibility_p2p',
            'myc_flexible_capacity_in_industry_flexibility_p2h_chemicals',
            'myc_flexible_capacity_in_industry_flexibility_p2h_fertilizers',
            'myc_flexible_capacity_in_industry_flexibility_p2h_food',
            'myc_flexible_capacity_in_industry_flexibility_p2h_paper',
            'myc_flexible_capacity_in_industry_flexibility_p2h_refineries',
            'myc_flexible_capacity_in_industry_flexibility_p2h',
            'myc_flexible_capacity_in_transport_bus_using',
            'myc_flexible_capacity_in_transport_car_using',
            'myc_flexible_capacity_in_transport_truck_using',
            'myc_flexible_capacity_in_transport_van_using',
            'myc_flexible_capacity_in_load_shifting_chemical_industry',
            'myc_flexible_capacity_in_load_shifting_metal_industry',
            'myc_flexible_capacity_in_load_shifting_other_ict_industry',
            'myc_flexible_capacity_in_load_shifting_other_industry'
        ]
      }
    ]
  };
